import Component from '@glimmer/component';
export default class PlayerVerticalComponent extends Component {}
